const mobile = 991;
const desktop = 1199;

function getDocumentWidth() {
	return window.innerWidth || document.documentElement.clientWidth;
}

function breakpoint() {
	const width = getDocumentWidth();
	let bp = '';

	if ( width < mobile ) {
		bp = 'mobile';
	} else if ( width >= desktop ) {
		bp = 'desktop';
	}

	return bp;
}

export default breakpoint;
